export interface IGetStateDefinitionByIdDto {
    includeExternal?: boolean;
}
